<template>
  <div class="part-one">
    <p class="top">时间：10月1日10:00:00-10月3日23:59:59</p>
    <button class="go-app" @click.stop="ToLeiDianApp"></button>
  </div>
</template>

<script>
export default {
  name: "Partone",
  methods: {
    isMobile() {
      //detection PC and Mobile
      if (
        !!window.navigator.userAgent.match(/AppleWebKit.*Mobile.*/) &&
        !!window.navigator.userAgent.match(/AppleWebKit/)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isWeiXin() {
      var agent = window.navigator.userAgent.toLowerCase();
      return agent.match(/MicroMessenger/i) == "micromessenger";
    },
    isQQ() {
      var agent = window.navigator.userAgent.toLowerCase();
      return agent.match(/QQ/i) == "qq";
    },
    //跳转雷电APP
    ToLeiDianApp() {
      if (!this.isMobile() || this.isWeiXin() || this.isQQ()) {
        console.log(1)
        window.location.href = "http://www.ldmnq.com/ldq/";
        return;
      }
      var hasApp = true;
      var t = 2000;
      setTimeout(function() {
        //没有安装APP则跳转至应用宝下载，延时时间设置为2秒
        if (!hasApp) {
          window.location.href = "http://www.ldmnq.com/ldq/";
        }
      }, 2500);
      // var iframe = document.createElement("iframe");
      // iframe.src = "dianquan://ld.com/game";
      // iframe.style.display = "none";
      // document.body.appendChild(iframe);
        window.location.href = "dianquan://ld.com/game";

      var t1 = Date.now();
      setTimeout(function() {
        //t的时间就是出发APP启动的时间，若APP启动了，再次返回页面时t2这行代码执行，hasApp即为true。反之若APP没有启动即为false
        var t2 = Date.now();
        hasApp = !(!t1 || t2 - t1 < t + 200);
        // document.body.removeChild(iframe);
        // window.location.href = "http://www.ldmnq.com/ldq/";
      }, t);
    }
  }
};
</script>

<style lang="scss" scoped>
.part-one {
  position: relative;
  width: 100%;
  height: 280px;
  background-image: url("../assets/huodong1-min.png");
  background-size: 100% 100%;
  padding-top: 260px;
  .top {
    display: inline-block;
    padding:8px 20px;
    font-size: 24px;
    color: #461e01;
    background-image: url("../assets/kuang-min.png");
    background-size: 100% 100%;
  }
  .go-app {
    cursor: pointer;
    position: absolute;
    bottom: 130px;
    left: 50%;
    transform: translateX(-50%);
    width: 400px;
    height: 80px;
    border-radius: 40px;
  }
  margin-bottom: 60px;
}
</style>